module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/registry-fund-a1fa5614833d5e744d110cb6319e99cf.png";